import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { uniqBy, pickAll, is } from 'ramda';

import MedicationSearch from '../components/MedicationSearch';
import MedicationSearchDialog from '../components/MedicationSearchDialog';

import { get } from 'lib/communication';
import debounce from 'lib/debounce';

const initialState = {
  dialogOpen: false,
  isLoading: false,
  searchResults: [],
  selection: null,
  viewPortSize: { width: window.innerWidth, height: window.innerHeight },
};

class MedicationSearchContainer extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.handleClose = () => this.setState(initialState);
    this.handleDialogToggle = () => this.setState({ dialogOpen: !this.state.dialogOpen });
    this.handleSelectMedication = selection => this.setState({ selection: this.state.searchResults[selection] });

    this.handleChooseMedication = () => {
      const drug = this.state.selection;
      this.props.input.onChange({
        name: drug.name,
        dosageForm: drug.dosageForm,
        substances: drug.substanceString,
        strength: null, // Clear this if the medication is changed
      });
      this.handleClose();
    };

    this.search = str => {
      if (!this.state.isLoading) {
        if (str.length >= 3) {
          this.setState({ isLoading: true });
          get(`/medication/search?search=${str}`)
            .then(res => {
              return Array.isArray(res) ? res : [];
            })
            .then(data => {
              this.setState({
                isLoading: false,
                selection: null,
                searchResults: uniqBy(pickAll(['atc', 'dosageForm']), data).map((med, i) => ({ ...med, medIndex: i })),
              });
            });
        }
      } else {
        this.handleSearch(str);
      }
    };

    this.handleSearch = debounce(this.search, 750, this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateViewport.bind(this));
    this.updateViewport();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateViewport.bind(this));
  }

  componentDidUpdate() {
    if (
      this.state.dialogOpen &&
      (this.state.viewPortSize.width !== window.innerWidth || this.state.viewPortSize.height !== window.innerHeight)
    ) {
      this.updateViewport();
    }
  }

  updateViewport() {
    this.setState({ viewPortSize: { width: window.innerWidth, height: window.innerHeight } });
  }

  render() {
    const { editing, localeMessage, input } = this.props;
    const { dialogOpen, searchResults, selection, isLoading } = this.state;

    if (editing) {
      return (
        <div>
          <MedicationSearch
            onDialogToggle={this.handleDialogToggle}
            value={is(Object, input.value) ? input.value : null}
            localeMessage={localeMessage}
          />
          <MedicationSearchDialog
            open={dialogOpen}
            results={searchResults}
            selection={selection}
            onSearch={this.handleSearch}
            onSelect={this.handleSelectMedication}
            onChoose={this.handleChooseMedication}
            onClose={this.handleClose}
            localeMessage={localeMessage}
            resultsLoad={isLoading}
            viewPortSize={this.state.viewPortSize}
          />
        </div>
      );
    }
    return (
      <MedicationSearch
        onDialogToggle={this.handleDialogToggle}
        value={is(Object, input.value) ? input.value : null}
        localeMessage={localeMessage}
        viewMode
      />
    );
  }
}

MedicationSearchContainer.propTypes = {
  editing: PropTypes.bool.isRequired,
  localeMessage: PropTypes.func.isRequired,
  input: PropTypes.object.isRequired,
};

export default MedicationSearchContainer;
